import { Autocomplete, Button, ButtonBase, Paper, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField } from '@mui/material'
import BackspaceIcon from '@mui/icons-material/Backspace';
import { Box, Stack, styled } from '@mui/system'
import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from "axios"
import qz from "qz-tray";
import Clock from 'react-live-clock';  
import moment from 'moment';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useReactToPrint } from 'react-to-print';
import { ComponentToPrint } from './ComponentToPrint'
import PaymentDialog from './PaymentDialog';
import EditCartItemDialog from './EditCartItemDialog';
import SearchCartItemDialog from './SearchCartItemDialog';
import DraftOrderDialog from './DraftOrderDialog';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Search from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import NewOrderDialog from './NewOrderDialog';
import { autocompleteClasses } from '@mui/material/Autocomplete';
import useMediaQuery from '@mui/material/useMediaQuery';
import Popper from '@mui/material/Popper';
import { useTheme } from '@mui/material/styles';
import { VariableSizeList } from 'react-window';
import Typography from '@mui/material/Typography';
import LoaderDialog from './LoaderDialog';
import { AuthContext } from '../authContext/AuthContext';
import { getPriceNumber, getQtyNumber } from '../util.js'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1776d1',
    color: 'white',
  }
}));

const Leftbar = () => {
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const todaysDate = moment(new Date()).format('DD/MM/YYYY');
  const [searchword, setSearchword] = useState("");
  const [items, setItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalRoundOff, setTotalRoundOff] = useState(0);
  const [totalSavings, setTotalSavings] = useState(0);
  const [invoiceId, setInvoiceId] = useState();
  const [pytMode, setPytMode] = useState();
  const [field, setField] = useState(false);
  const [draftOrders, setDraftOrders] = useState([]);
  const [draftInvoice, setDraftInvoice] = useState(false)

  const [qty, setQty] = useState("");
  const [tax, setTax] = useState();
  const [openAutoComplete, setOpenAutoComplete] = useState(false);
  const [active, setActive] = useState('q');
  const [qtyTotal, setQtyTotal] = useState();
  const [gstTotal, setGstTotal] = useState();
  const [waiter, setWaiter] = useState();
  const [loading, setLoading] = useState(false);
  const { user, shop } = useContext(AuthContext)
  const [shopName, setShopName] = useState("");
  const [odTime, setOdTime] = useState(new Date());
  const [shopSettingsList, setShopSettingsList] = useState([]);
  
  /**
 * Autocomplete improvement
 */
 const LISTBOX_PADDING = 8; // px

 function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
  };

  return (
    <Typography component="li" {...dataSet[0]} style={inlineStyle}>
      {dataSet[1].itemKey} | {dataSet[1].itemName.toUpperCase()} | {dataSet[1].sellingPriceInclTax}
    </Typography>
  );
}
 
 const OuterElementContext = React.createContext({});
 
 const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});
 
function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}
 
 // Adapter for react-window
 const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
  });
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });
  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;
  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemCount * itemSize;
  };
  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={() => itemSize}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});
 
 const StyledPopper = styled(Popper)({
   [`& .${autocompleteClasses.listbox}`]: {
     boxSizing: 'border-box',
     '& ul': {
       padding: 0,
       margin: 0,
     },
   },
 });

  const sty = {
    Input: {
      "&.Mui-disabled": {
        borderBottom: "solid",
        borderColor: "green",
        borderWidth: "3px"
      }
    }
  };
  const [styles, setStyles] = useState(sty);
  const [styles1, setStyles1] = useState({});

  const handleSearchBox = (value) => {
    if(active === 's') {
      setOpenAutoComplete(true);
      if(value==="BACK") {
        if(searchword !== "") {
          setSearchword(searchword.slice(0, -1))
        }
        document.getElementById("autocomplete").focus();
      } else if(value === "ENTER") {
        const si = JSON.parse(localStorage.getItem("selectedItem"))
        localStorage.removeItem("selectedItem")
        si && updateItemOnPressEnterFromItemSearch(si)
      } else if(value===".") {
        if(!searchword.includes(value)) {
          setSearchword(searchword + value);
        }
        document.getElementById("autocomplete").focus();
      } else {
        setSearchword(searchword + value);
        document.getElementById("autocomplete").focus();
      }
    } else if(active === 'q') {
      if(value === "BACK") {
        if(qty !== "") {
          setQty(qty.slice(0, -1))
        }
        document.getElementById("qty").focus();
      } else if(value === "ENTER") {
        if(qty === "" || qty.startsWith("0")) {
          document.getElementById("qty").focus();
        } else {
          setField(!field)
          setStyles(field ? sty:{});
          setStyles1(field ? {}: sty)
          setSearchword("");
          setActive("s");
          document.getElementById("autocomplete").focus();
          setOpenAutoComplete(true);
        }
      } else if(value===".") {
        if(!qty.includes(value)) {
          setQty(qty + value);
        }
        document.getElementById("qty").focus();
      } else {
        setQty(qty + value)
        document.getElementById("qty").focus();
      }
    }
  };

  const updateItemOnPressEnterFromItemSearch = (item) => {
    setField(!field)
    setStyles(field ? sty:{})
    setStyles1(field ? {}: sty)
    // handleItem(item.itemKey, Number.parseFloat(qty).toFixed(3));
    handleCart(item, getQtyNumber(qty))
    setOpenAutoComplete(false)
    setActive("q");
    document.getElementById("qty").focus();
    setQty("");
    setSearchword("");
  }

  const createItem = (_id, itemKey, itemName, stock, sellingPriceExclTax, sgst, cgst, sellingPriceInclTax, unitOfMeasurement, isTokenRequired, discountInPercentage) => {
    return { 
      _id,
      itemKey, 
      itemName, 
      stock, 
      sellingPriceExclTax, 
      sgst, 
      cgst, 
      sellingPriceInclTax, 
      unitOfMeasurement,
      isTokenRequired,
      discountInPercentage
    };
  }

  const handleCart = (item, quantity) => {
    let found = false;
    let updatedCart = cart.map((c) => {
      if (c.itemKey === item.itemKey) {
        found = true;
        return updateCartItem(c, quantity, found);
      } else {
        return c;
      }
    });
    if(found === false) {
      updatedCart.push(updateCartItem(item, quantity, found));
    }
    setCart(updatedCart);
  }

  const updateCartItem = (item, quantity, found) => {
    const q = found ? getQtyNumber(item.quantity) + getQtyNumber(quantity) : getQtyNumber(quantity);
    const s = getQtyNumber(item.stock) - getQtyNumber(quantity)
    
    const discountMultiplier = (100 - (item.discountInPercentage || 0)) / 100;
    const spet = getPriceNumber(q * item.sellingPriceExclTax * discountMultiplier)
    const spit = getPriceNumber(q * item.sellingPriceInclTax * discountMultiplier);
    const sgstamount = getPriceNumber((spet * item.sgst)/100);
    const cgstamount = getPriceNumber((spet * item.cgst)/100);
    return {...item, quantity: getQtyNumber(q), stock: getQtyNumber(s), spet, spit, sgstamount, cgstamount, discountInPercentage: item.discountInPercentage, isTokenRequired: item.isTokenRequired};
  }

  const deleteItemFromCart = (item) => {
    setCart(cart.filter((c) => c.itemKey !== item.itemKey));
    // handleItem(item.itemKey, -item.quantity);
  }

  useEffect(() => {
    const updateCalculation = () => {
      let spet = 0;
      let spit = 0;
      let sgstVal = 0;
      let cgstVal = 0;
      let originalSpit = 0;
      let actualSpit = 0;
      cart.forEach((c)=> {
        const discountMultiplier = (100 - (c.discountInPercentage || 0)) / 100;
        let tprice = getPriceNumber(c.quantity * c.sellingPriceExclTax * discountMultiplier)
        spet += getPriceNumber(tprice);
        spit += getPriceNumber(c.quantity * c.sellingPriceInclTax * discountMultiplier)
        sgstVal += getPriceNumber((tprice * c.sgst)/100)
        cgstVal += getPriceNumber((tprice * c.cgst)/100)
        originalSpit += getPriceNumber(c.quantity * c.sellingPriceInclTax);
        actualSpit += getPriceNumber(c.quantity * c.sellingPriceInclTax * discountMultiplier);
      });
      setSubTotal(getPriceNumber(spet));
      let actual = Math.round(spit);
      setTotal(getPriceNumber(actual));
      setTotalRoundOff(getPriceNumber(actual - (spet + sgstVal + cgstVal)));
      setSgst(sgstVal);
      setCgst(cgstVal);
      setTotalSavings(Math.round(originalSpit) - Math.round(actualSpit));
    };
    updateCalculation();
  },[cart]);

  const loadDraftOrder = async(user, shop) => {
    try {
      const res = await axios.get("/orders/draft", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      if (!isMounted.current) return;
      const data = [];
      res.data.map(item => data.push(item));
      setDraftOrders(data)
    } catch (err) {
      console.log(err)
    }
  };
  useEffect(() => {
    loadDraftOrder(user, shop);
  },[user, shop]);

  const deleteDraftOrder = async(id) => {
    try {
      await axios.delete("/orders/draft?id=" + id, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      if (!isMounted.current) return;
      loadDraftOrder(user, shop)
      if(draftInvoice === true) {
        handleNewInvoice()
      }
    } catch (err) {
      console.log(err)
    }
  }
  
  /*const handleItem = (itemKey, quantity) => {
    let updatedItems = items.map((i) => {
      if (i.itemKey === itemKey) {
        const s = Number.parseFloat(i.stock) - Number.parseFloat(quantity);
        let tprice = (Math.trunc((quantity * i.sellingPriceExclTax)*100)/100).toFixed(2)
        const spet = Number.parseFloat(tprice);
        const spit = Number.parseFloat((Math.trunc((quantity * i.sellingPriceInclTax)*100)/100).toFixed(2));
        const sgstamount = Number.parseFloat((Math.trunc(((tprice * i.sgst)/100)*100)/100).toFixed(2));
        const cgstamount = Number.parseFloat((Math.trunc(((tprice * i.cgst)/100)*100)/100).toFixed(2));
        return { ...i, stock: s.toFixed(3), spet, spit, sgstamount, cgstamount};
      } else {
        return i;
      }
    });
    setItems(updatedItems);
  }
  */

  useEffect(() => {
    const getItemsAndSettings = async() => {
      try {
        let settingsList = shop.settings || [];
        setShopSettingsList(settingsList);

        const res = await axios.get("/items/active", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        if (!isMounted.current) return;
        const data = [];
        res.data.map((item) => {
          if (item.delete === false) {
            let matchedSetting = null;
            let maxDepth = -1;
            settingsList.forEach(setting => {
              if (setting.shopKey === shop.shopkey) {
                let depth = 0;
                let matches = true;
                if (setting.mainCategory) {
                  if (setting.mainCategory === item.itemMainCategory) depth = 1;
                  else matches = false;
                }
                if (setting.subCategory) {
                  if (setting.subCategory === item.itemSubCategory) depth = 2;
                  else matches = false;
                }
                if (setting.subSubCategory) {
                  if (setting.subSubCategory === item.itemSubsubCategory) depth = 3;
                  else matches = false;
                }
                if (setting.itemKey) {
                  if (setting.itemKey === item.itemKey) depth = 4;
                  else matches = false;
                }
                if (matches && depth > maxDepth) {
                  maxDepth = depth;
                  matchedSetting = setting;
                }
              }
            });
            const itemSettings = matchedSetting ? matchedSetting.settings : { isTokenRequired: false, discountInPercentage: 0 };
            data.push(createItem(item._id, item.itemKey, item.itemName, item.stock, item.sellingPriceExclTax, item.sgst, item.cgst, item.sellingPriceInclTax, item.unitOfMeasurement, itemSettings.isTokenRequired, itemSettings.discountInPercentage));
          }
          return null;
        });
        setItems(data)
      } catch (err) {
        console.log(err)
      }
    };
    
    getItemsAndSettings();
  },[user, shop]);

  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    const validate = async() => {
      setDisabled(cart.length === 0)
    };
    validate();
  },[cart]);

  const loadDraftOrderToCart = async(draftOrder) => {
    setCart(draftOrder.cart)
    setInvoiceId(draftOrder._id)
    setPytMode(draftOrder.paymentMode)
    setSubTotal(draftOrder.subtotal)
    setSgst(draftOrder.sgst)
    setCgst(draftOrder.cgst)
    setTotal(draftOrder.total)
    setDraftInvoice(true)
  }
  const handlePayment = async(paymentMode, paymentRefNum, customerMobile, draft, draftName) => {
    try {
      setLoading(true)
      handleClosePayment()
      handleCloseDraft()
      const customer = {"phone": customerMobile}
      let printInvoiceId = invoiceId;

      const shopSetting = shopSettingsList?.find(s => !s.mainCategory && !s.subCategory && !s.subSubCategory && !s.itemKey) || shop.settings?.find(s => !s.mainCategory && !s.subCategory && !s.subSubCategory && !s.itemKey);

      if(draftInvoice === false) {
        const order = {cart, subtotal: subTotal, sgst, cgst, total, totalRoundOff, totalSavings, orderDate: todaysDate, user, paymentMode, paymentRefNum, customer, draft, draftName, shopkey: shop.shopkey}
        const res = await axios.post("/orders", order, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        await handleTransfer()
        setInvoiceId(res.data._id)
        printInvoiceId = res.data._id
        setPytMode(paymentMode)
      } else {
        const order = {"_id": invoiceId, cart, subtotal: subTotal, sgst, cgst, total, totalRoundOff, totalSavings, orderDate: todaysDate, user, paymentMode, paymentRefNum, customer, draft, draftName, shopkey: shop.shopkey}
        await axios.put("/orders?id=" + invoiceId, order, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        setDraftInvoice(false)
		await handleTransfer()
        setPytMode(paymentMode)
      }
      // We are not updating cart quantity/stock so, no need to update back to table
      /*if(draft === false) {
        await Promise.all(
          cart.map(async (c)=> {
            await axios.put("/items/" + c._id, c, {headers: {token:"Bearer " + loginUser.token}})
          })
        );
      }*/
      if(draft === false) {
        const groupByGST = cart.reduce((group, item) => {
          const gst = item.cgst + item.sgst
          group[gst] = group[gst] ?? [];
          group[gst].push(item);
          return group;
        }, {});
        let tax = [];
        let qtyCount = 0;
        let gstall = 0;
        for (const [key, value] of Object.entries(groupByGST)) {
          let valueTotal = 0;
          let cgstValueTotal = 0
          let sgstValueTotal = 0
          let qc = 0;
          value.forEach((c)=> {
            qc += getQtyNumber(c.quantity);
            const discountMultiplier = (100 - (c.discountInPercentage || 0)) / 100;
            const val = getPriceNumber(c.quantity * c.sellingPriceExclTax * discountMultiplier)
            valueTotal += val
            cgstValueTotal += getPriceNumber((val * c.cgst)/100)
            sgstValueTotal += getPriceNumber((val * c.sgst)/100)
          });
          qtyCount += qc;
          cgstValueTotal = (Math.trunc(cgstValueTotal*100)/100).toFixed(2)
          sgstValueTotal = (Math.trunc(sgstValueTotal*100)/100).toFixed(2)
          valueTotal = (Math.trunc(valueTotal*100)/100).toFixed(2)
          gstall = gstall + Number.parseFloat(cgstValueTotal) + Number.parseFloat(sgstValueTotal)
          tax.push({"gst": key, "cgst": Number.parseInt(key)/2, "cgstvalue": cgstValueTotal, "sgst": Number.parseInt(key)/2, "sgstvalue": sgstValueTotal, "valueTotal": valueTotal})
        }
        setGstTotal((Math.trunc(gstall*100)/100).toFixed(2))
        setTax(tax)
        setQtyTotal((Math.trunc(qtyCount*100)/100).toFixed(2));
        setWaiter(JSON.parse(localStorage.getItem("user")).name)
        const sName = (shop.shopkey === "BK" || shop.shopkey === "CBK") ? "SRI KUMARAN SWEETS AND BAKERY"  : (shop.shopkey === "SKR") ? "SRI KUMARAN RUCHI" : "SRI KUMARAN SWEETS";
        setShopName(sName)
        
        const useNativeBrowserPrint = shopSetting?.settings?.useNativeBrowserPrint ?? true;
        if (useNativeBrowserPrint) {
          handleReactToPrint()
        } else {
          await handleThermalPrint({
            invoiceId: printInvoiceId,
            cart, subtotal: subTotal, sgst, cgst, total, totalRoundOff, totalSavings,
            gstTotal: (Math.trunc(gstall*100)/100).toFixed(2),
            tax, qty: (Math.trunc(qtyCount*100)/100).toFixed(2),
            orderDate: todaysDate, orderTime: new Date(),
            waiter: JSON.parse(localStorage.getItem("user")).name,
            shopName: sName, pytMode: paymentMode, shop
          });
        }
      } 
      if(draftInvoice === true || draft === true) {
        loadDraftOrder(user, shop);
      }
      if (isMounted.current) {
        setCart([])
        setSubTotal(0)
        setSgst(0)
        setCgst(0)
        setTotal(0)
        setTotalSavings(0)
        setLoading(false)
        setQty("")
        setSearchword("")
        setField(false)
        setActive("q")
        setTimeout(() => setDefaultInput(), 100);
      }
    } catch (err) {
      console.log(err)
      if (isMounted.current) setLoading(false)
    }
  };

  const handleTransfer = async() => {
    let updatedCart = cart.map(c => {return {itemKey: c.itemKey, itemName: c.itemName, from: shop.shopkey, to: "C", qty: c.quantity, type: "Sales", transactionDate: new Date(), shopkey: shop.shopkey, discountInPercentage: c.discountInPercentage, isTokenRequired: c.isTokenRequired}})
    try {
      await axios.post("/transactions", updatedCart, {headers: {token:"Bearer " + user.token}})
    } catch (err) {
      console.log(err)
    }
  };

  const handleNewInvoice = async() => {
    handleOpenNewInvoice()
    setCart([])
    setSubTotal(0)
    setSgst(0)
    setCgst(0)
    setTotal(0)
    setTotalSavings(0)
    setQty("")
    setSearchword("")
    setField(false)
    setActive("q")
    setTimeout(() => setDefaultInput(), 100);
  }

  const handleThermalPrint = async (printPayload) => {
    try {
      const response = await axios.post("/print/thermal", printPayload, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}});
      
      if (response.data && response.data.base64Data) {
        if (!qz.websocket.isActive()) {
          qz.security.setSignatureAlgorithm("SHA512");
          qz.security.setCertificatePromise(function(resolve, reject) {
            // Backend looks up cert by user token
            axios.get("/print/certificate", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
              .then(res => resolve(res.data))
              .catch(reject);
          });
          qz.security.setSignaturePromise(function(toSign) {
            return function(resolve, reject) {
              axios.post("/print/sign", { request: toSign }, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
                .then(res => resolve(res.data))
                .catch(reject);
            };
          });
          await qz.websocket.connect();
        }
        const printerName = response.data.printerName || "EPSON";
        const config = qz.configs.create(printerName);
        const printData = [{
          type: 'raw',
          format: 'base64',
          data: response.data.base64Data
        }];
        await qz.print(config, printData);
      }
    } catch (err) {
      console.error("Thermal Print Error:", err);
      alert("Thermal printing failed. Ensure QZ Tray is running and printer is connected. Falling back to browser print.");
      handleReactToPrint();
    }
  };

  const images = [
    {
      title: '7',
      width: '33%',
    },
    {
      title: '8',
      width: '32.5%',
    },
    {
      title: '9',
      width: '33%',
    },
    {
      title: '4',
      width: '33%',
    },
    {
      title: '5',
      width: '32.5%',
    },
    {
      title: '6',
      width: '33%',
    },
    {
      title: '1',
      width: '33%',
    },
    {
      title: '2',
      width: '32.5%',
    },
    {
      title: '3',
      width: '33%',
    },
    {
      title: '.',
      width: '33%',
    },
    {
      title: '0',
      width: '32.5%',
    },
    {
      title: 'BACK',
      width: '33%',
    },
    {
      title: 'ENTER',
      width: '99%',
    },
  ];

  const ImageButton = styled(ButtonBase)(({ theme }) => ({
    position: 'relative',
    height: 96,
    [theme.breakpoints.down('sm')]: {
      width: '100% !important', // Overrides inline-style
      height: 96,
    },
    '&:hover, &.Mui-focusVisible': {
      zIndex: 1,
      '& .MuiImageBackdrop-root': {
        opacity: 0.15,
      },
      '& .MuiImageMarked-root': {
        opacity: 0,
      },
      '& .MuiTypography-root': {
        border: '4px solid currentColor',
      },
    },
    backgroundColor: 'green',
    color: 'white',
    font: '25',
    margin: '.5px'
  }));

  const componentRef= useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => setDefaultInput()
  })

  const [openPayment, setOpenPayment] = useState(false);
  const handleClosePayment = () => {
    setOpenPayment(false);
  };
  const handleClickOpenPayment = () => {
    setOdTime(new Date());
    setOpenPayment(true);
  };
  const [editCartItem, setEditCartItem] = useState();
  const [openEditCartItem, setOpenEditCartItem] = useState(false);
  const handleCloseEditCartItem = () => {
    setOpenEditCartItem(false);
  };
  const handleClickOpenEditCartItem = (item) => {
    setEditCartItem(item);
    setOpenEditCartItem(true);
  };
  const handleEditCartItem = (updatedItemKey, updatedQuantity) => {
    handleCloseEditCartItem();
    let updatedCart = cart.map((c) => {
      if (c.itemKey === updatedItemKey) {
        const q = getQtyNumber(updatedQuantity);
        const s = getQtyNumber(c.stock) + getQtyNumber(c.quantity) - getQtyNumber(updatedQuantity);
        const discountMultiplier = (100 - (c.discountInPercentage || 0)) / 100;
        let tprice = getPriceNumber(q * c.sellingPriceExclTax * discountMultiplier)
        const spet = getPriceNumber(tprice);
        const spit = getPriceNumber(q * c.sellingPriceInclTax * discountMultiplier);
        const sgstamount = getPriceNumber((tprice * c.sgst)/100)
        const cgstamount = getPriceNumber((tprice * c.cgst)/100)
        return { ...c, quantity: getQtyNumber(q), stock: getQtyNumber(s), spet, spit, sgstamount, cgstamount, discountInPercentage: c.discountInPercentage, isTokenRequired: c.isTokenRequired};
      } else {
        return c;
      }
    });
    setCart(updatedCart);
  };
  const [openSearchCartItem, setOpenSearchCartItem] = useState(false);
  const handleCloseSearchCartItem = () => {
    setOpenSearchCartItem(false);
  };
  const handleClickOpenSearchCartItem = () => {
    setOpenSearchCartItem(true);
  };
  const handleSearchCartItem = (updatedSelectedItem) => {
    handleCloseSearchCartItem()
    if(updatedSelectedItem) {
      setSearchword(updatedSelectedItem.itemKey.toString());
    }
  };
  const [openDraft, setOpenDraft] = useState(false);
  const handleCloseDraft = () => {
    setOpenDraft(false);
  };
  const handleClickOpenDraft = () => {
    setOpenDraft(true);
  };
  const [openNewInvoice, setOpenNewInvoice] = useState(false);
  const handleOpenNewInvoice = () => {
    setOpenNewInvoice(false);
  };
  const handleClickOpenNewInvoice = () => {
    setOpenNewInvoice(true);
  };

  const setDefaultInput = () => {
    document.getElementById("qty")?.focus();
  };

  useEffect(() => {
    setDefaultInput();
  }, []);

  useEffect(() => {
    setDefaultInput();
  }, [openEditCartItem, openDraft, openNewInvoice, openPayment, openSearchCartItem]);
  
  return (
    <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Preparing for print ..."/>
      <div style={{display: 'none'}}>
        <ComponentToPrint ref={componentRef} invoiceId={invoiceId} cart={cart} subtotal={subTotal} total={total} orderDate={todaysDate} qty={qtyTotal} tax={tax} gstTotal={gstTotal} waiter={waiter} totalRoundOff={totalRoundOff} shop={shop} shopName={shopName} pytMode={pytMode} orderTime={odTime} totalSavings={totalSavings}/>
      </div>
      <Grid container>
          <Grid item xs={6} sx={{paddingTop: .5, paddingLeft: .5}}>
            <Paper sx={{ overflow: 'hidden' }}>
              <Box align="center" sx={{fontSize:20, fontWeight: "bold", color:"red"}}>*** {field ? "Select item from list": "Enter quantity : Select the number and press enter"} ***</Box>
              <TableContainer sx={{ maxHeight: "58vh", minHeight: "58vh" }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell colSpan="2" sx={{fontSize:20,  fontWeight: "bold"}}>{todaysDate}</StyledTableCell>
                      <StyledTableCell colSpan="3" sx={{fontSize:20,  fontWeight: "bold"}}>INVOICE</StyledTableCell>
                      <StyledTableCell align="right" sx={{fontSize:20,  fontWeight: "bold"}}><Clock format={'HH:mm:ss'} ticking={true} date={null} /></StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell>#</StyledTableCell>
                      <StyledTableCell align="right">QTY</StyledTableCell>
                      <StyledTableCell align="left">CODE - NAME</StyledTableCell>
                      <StyledTableCell align="right">RATE</StyledTableCell>
                      <StyledTableCell align="right">AMOUNT</StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {cart.map((item, index) => {
                    const discountMultiplier = (100 - (item.discountInPercentage || 0)) / 100;
                    return (
                    <TableRow key={item.itemKey + '_' + index} hover>
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell align="right">{item.quantity.toFixed(3)}</StyledTableCell>
                      <StyledTableCell align="left">{item.itemKey} - {item.itemName.toUpperCase()} {item.discountInPercentage > 0 ? `(-${item.discountInPercentage}%)` : ''}</StyledTableCell>
                      <StyledTableCell align="right">{item.sellingPriceInclTax}</StyledTableCell>
                      <StyledTableCell align="right" sx={{fontSize:15,  fontWeight: "bold"}}>{getPriceNumber(item.quantity * item.sellingPriceExclTax * discountMultiplier).toFixed(2)}</StyledTableCell>
                      <StyledTableCell>
                        <DeleteIcon color="error" onClick={() => {deleteItemFromCart(item)}}  size="small"></DeleteIcon>
                        <EditIcon color="primary"  onClick={() => {handleClickOpenEditCartItem(item)}}  size="small"></EditIcon>
                      </StyledTableCell>
                    </TableRow>
                  )})}
                    <TableRow>
                      <StyledTableCell></StyledTableCell>
                      <StyledTableCell align="right">
                        <TextField direction="rtl" variant="standard" disabled id="qty" size="small" value={qty} placeholder="0.0" onChange={(event)=> setQty(event.target.value)}  sx={styles}/>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Stack direction="row">
                          <Autocomplete
                            id="autocomplete"
                            PopperComponent={StyledPopper}
                            ListboxComponent={ListboxComponent}
                            renderOption={(props, option) => [props, option]}
                            open={openAutoComplete}
                            onOpen={() => setOpenAutoComplete(true)}
                            onClose={() => setOpenAutoComplete(false)}
                            size="small"
                            sx={styles1}
                            options={items}
                            value={null}
                            autoHighlight
                            onHighlightChange={(event, option, reason) => {localStorage.setItem("selectedItem", JSON.stringify(option))}}
                            getOptionLabel={(option) =>  option.itemKey.toString()}
                            renderInput={(params) => (
                              <TextField
                                sx={{width: 300}}
                                {...params}
                                inputProps={{
                                  ...params.inputProps
                                }}
                                variant="standard"
                                size="small"
                                color="success"
                              />
                            )}
                            inputValue={searchword}
                            onChange={(event, newItem) => {
                              if(qty !== "") {
                                updateItemOnPressEnterFromItemSearch(newItem)
                              }
                            }}
                            disabled
                          />
                          <IconButton color="primary" size="small" disabled={!openAutoComplete} onClick={() => {handleClickOpenSearchCartItem()}}>
                          <Search/>
                          </IconButton>
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                      <StyledTableCell></StyledTableCell>
                    </TableRow>
                </TableBody>
                </Table>
              </TableContainer>
              <TableContainer sx={{ maxHeight: "29vh", minHeight: "29vh", paddingTop: 2 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell colSpan="4" align="center" sx={{fontSize:20,  fontWeight: "bold"}}>Draft Invoices</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell>#</StyledTableCell>
                      <StyledTableCell>Invoice #</StyledTableCell>
                      <StyledTableCell>Draft Name</StyledTableCell>
                      <StyledTableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {draftOrders.map((draft, index) => (
                        <TableRow key={draft._id}>
                          <StyledTableCell>{index + 1}</StyledTableCell>
                          <StyledTableCell>{draft._id}</StyledTableCell>
                          <StyledTableCell>{draft.draftName}</StyledTableCell>
                          <StyledTableCell>
                            <OpenInNewIcon color="primary" onClick={() => {loadDraftOrderToCart(draft)}} size="small"/>
                            <DeleteIcon color="error" onClick={() => {deleteDraftOrder(draft._id)}} size="small"/>
                          </StyledTableCell>
                        </TableRow>
                    ))}
                  </TableBody>
              </Table>      
            </TableContainer>
            </Paper>
          </Grid>
          <Grid item xs={6}>
              <Box sx={{ flexWrap: 'wrap', paddingTop: .5, paddingLeft: .5, height: "62vh"}}>
                <Paper sx={{ overflow: 'hidden' }}>
                  {images.map((image) => (
                    <ImageButton
                      focusRipple
                      key={image.title}
                      style={{width: image.width, height: "12vh", backgroundColor: '#1776d1', color: 'white', fontSize:80, fontWeight: "bold"}}
                      onClick={() => handleSearchBox(image.title)}>
                        {image.title === "BACK" ? <BackspaceIcon /> : image.title }
                    </ImageButton>
                  ))}
                </Paper>
              </Box>
              <Box sx={{ paddingTop: .5, paddingLeft: .5, paddingRight: .5}}>
                <Paper sx={{ overflow: 'hidden' }}>
                  <TableContainer sx={{ maxHeight: "30vh", minHeight: "29vh"}}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell colSpan="3" align="center" sx={{fontSize:20,  fontWeight: "bold"}}>SUMMARY</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      <TableRow>
                        <StyledTableCell sx={{fontSize:20, fontWeight: "bold"}}>SGST</StyledTableCell>
                        <StyledTableCell align="right" sx={{fontSize:20,  fontWeight: "bold"}}>{sgst.toFixed(2)}</StyledTableCell>
                        <StyledTableCell rowSpan="2">
                          <Button color="success" sx={{fontSize:40, fontWeight: "bold"}} margin="normal" onClick={handleClickOpenPayment} variant="outlined"  disabled={disabled} fullWidth>
                            Payment
                          </Button>
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell sx={{fontSize:20, fontWeight: "bold"}}>CGST</StyledTableCell>
                        <StyledTableCell align="right" sx={{fontSize:20,  fontWeight: "bold"}}>{cgst.toFixed(2)}</StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell sx={{fontSize:20, fontWeight: "bold"}}>SUBTOTAL</StyledTableCell>
                        <StyledTableCell align="right" sx={{color: "green", fontSize:20, fontWeight: "bold"}}>{subTotal.toFixed(2)}</StyledTableCell>
                        <StyledTableCell>
                          <Button sx={{fontSize:23, fontWeight: "bold"}} margin="normal" onClick={handleClickOpenDraft} variant="outlined"  disabled={disabled} fullWidth>
                            Draft invoice
                          </Button>
                        </StyledTableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableCell sx={{fontSize:25, fontWeight: "bold"}}>TOTAL</StyledTableCell>
                        <StyledTableCell align="right" sx={{color: "green", fontSize:25, fontWeight: "bold"}}>{total}</StyledTableCell>
                        <StyledTableCell>
                          <Button color="error" sx={{fontSize:23, fontWeight: "bold"}} margin="normal" onClick={handleClickOpenNewInvoice} variant="outlined" disabled={disabled} fullWidth>
                            New Invoice
                          </Button>
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
          </Grid>
        </Grid>
        <PaymentDialog open={openPayment} handleClose={handleClosePayment} handlePayment={handlePayment}/>
        <DraftOrderDialog open={openDraft} handleClose={handleCloseDraft} handlePayment={handlePayment}/>
        <NewOrderDialog open={openNewInvoice} handleClose={handleOpenNewInvoice} handleNewInvoice={handleNewInvoice}/>
        {editCartItem && <EditCartItemDialog open={openEditCartItem} handleClose={handleCloseEditCartItem} handleEditCartItem={handleEditCartItem} editCartItem={editCartItem}/>}
        {items.length >0 && <SearchCartItemDialog open={openSearchCartItem} handleClose={handleCloseSearchCartItem} handleSearchCartItem={handleSearchCartItem} items={items}/>}
    </Container>
  )
}

export default Leftbar
